import dayjs from 'dayjs';
import { api, apiController as _apiController, restartApiCotroller as _restartApiCotroller} from "@/utils/api";
import { apiNl, apiController, restartApiCotroller } from "@/utils/apiNl";
import { DASHBOARD_MODE } from "@/domain/Dashboard/dashboard";
const getResumeFromDevice = async (infraId, parameterId,source, dateFrom, dateTo) => {
  try {
    restartApiCotroller();
    const response = await apiNl.get(
      `measurements/infraestructure/${infraId}/parameters/${parameterId}/resume`,
      {
        params: {
          dateFrom,
          dateTo,
          source,
        },
        signal: apiController.signal,
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getInfraestructuresByLocation = async (locationId, mode = '') => {
  if(locationId) {
    try {
      _restartApiCotroller();
      const response = await api.get(
        `measurements/location/${locationId}/infraestructure/all/measurementTarget/principal`,
        {
           params: {
            ...mode && {mode},
          },
          signal: _apiController.signal,
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  } else {
    return []
  }
};

const getInfreaestructureById = async (infraId) => {
  try {
    _restartApiCotroller();
    const response = await api.get(
      `/measurements/infraestructure/${infraId}/measurementTarget/principal`,
      {
        signal: _apiController.signal,
      }
    );
    
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getReadingsV2 = async (measurementTargetId) => {
  try {
    const dateFrom = dayjs().subtract(24, 'hours').format('YYYY-MM-DD+HH:mm:ss');
    const dateTo = dayjs().add(12, 'hours').format('YYYY-MM-DD+HH:mm:ss');
    const response = await api.get(
      `historical/${measurementTargetId}/readings/v2?dateFrom=${dateFrom}&dateTo=${dateTo}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export {
  getResumeFromDevice,
  getInfraestructuresByLocation,
  getInfreaestructureById,
  getReadingsV2,
};
